import React from 'react';
import {Col, Row} from 'react-grid-system';
import {Drawable} from "../../../../res/images/Drawable";
import {getMobileOperatingSystem, OS} from "../../../../utils/CheckPlatform";
import {LinkProvider} from "../../../../res/LinkProvider";
import {Reference} from "../../../../res/Reference";

interface States {
}

interface Props {
}

class SDeskScreenshoot extends React.Component<Props, States> {

    state: States

    constructor(props: Props) {
        super(props)
        this.state = {}

    }

    render() {
        switch (getMobileOperatingSystem()) {
            case OS.android:
                return (<img
                    className="sdeskScreenshot"
                    src={Drawable.sdeskAndroidScreen}/>)
            case OS.iOS:
                return (<img
                    className="sdeskScreenshot"
                    src={Drawable.sdeskIosScreen}/>)
            case OS.unknow:
                return (<img
                    className="sdeskScreenshot"
                    src={Drawable.sdeskBoothScreen}/>)
        }
    }
}

export default SDeskScreenshoot;
